@if (html()) {
  <section class="sav-longform" aria-label="Guide">
    @if (heading() || intro()) {
      <header class="sav-longform-head">
        @if (heading()) {
          <h2>{{ heading() }}</h2>
        }
        <!-- Every section heading on the site carries a supporting line, so fall back to a generic
             one when the admin has set a heading but no intro — otherwise this block renders a
             bare heading and breaks the pattern. -->
        <p>{{ intro() || 'A practical guide to getting the best price.' }}</p>
      </header>
    }

    <!-- Printed in full, clamped by CSS. See the same block on the store page. -->
    <input
      type="checkbox"
      class="sav-readmore-input"
      [id]="toggleId"
      [attr.aria-controls]="toggleId + '-body'"
      aria-label="Show the full article"
    />
    <div
      [id]="toggleId + '-body'"
      class="sav-longform-content sav-readmore-rich"
      [class.is-clamped]="shouldShowToggle()"
      [innerHTML]="html() | trustedCmsHtml"
    ></div>

    @if (shouldShowToggle()) {
      <label class="sav-longform-toggle" [attr.for]="toggleId">
        <span class="sav-readmore-more">Read More</span>
        <span class="sav-readmore-less">Read Less</span>
        <span class="sav-longform-toggle-icon" aria-hidden="true">+</span>
      </label>
    }
  </section>
}
